<template>
    <select
        v-model="selected"
        :class="selectClass"
        @input="setValue($event)"
    >
        <option value="" v-if="unselectedLabel">{{ unselectedLabel }}</option>
        <optgroup
          v-for="(group, index) in items"
          :label="group.name"
          :key="group.name + index + 0"
        >
            <option
              v-for="(item, index) in group.items"
              :value="getValue(item)"
              :key="index + 0"
            >
              {{ getLabel(item) }}
            </option>
        </optgroup>
    </select>
</template>

<script>
export default {
  props: {
    items: {
      default: () => [],
      type: Array,
      required: true
    },
    valueAttribute: {
      default: 'id',
      type: String,
      required: false
    },
    labelAttribute: {
      default: 'name',
      type: String,
      required: false
    },
    selection: {
      default: '0',
      type: String | Number,
      required: false
    },
    selectClass: {
      default: 'right-chevron',
      type: String,
      required: false
    },
    noneLabel: {
      default: '',
      type: String,
      required: false
    }
  },
  data () {
    return {
      selected: null,
      unselectedLabel: this.noneLabel
    }
  },
  computed: {
    label () {
      let needle = this.selected
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i][this.valueAttribute] === needle) {
          return this.items[i][this.labelAttribute]
        }
      }
      return ''
    }
  },
  methods: {
    setValue (event) {
      this.selected = event.target.value
      const flattenArray = this.$_.flatten(this.$_.map(this.$_.keys(this.items), (val) => {
        return this.items[val].items
      }))
      let value = this.$_.find(flattenArray, { 'itemId': parseInt(this.selected) })
      this.$emit('update:selection', value)
    },
    getValue (item) {
      if (!isNaN(item)) {
        return item
      }
      return (typeof item[this.valueAttribute] !== 'undefined') ? item[this.valueAttribute] : item.id
    },
    getLabel (item) {
      if (!isNaN(item)) {
        return item
      }
      return (typeof item[this.labelAttribute] !== 'undefined') ? item[this.labelAttribute] : item.name
    }
  },
  mounted () {
    if (this.selection === '0' || this.selection === 0) {
      this.selected = this.items[0]
      this.$emit('update:selection', this.selected)
    }
    if (this.selection) {
      this.selected = this.selection
      this.$emit('update:selection', this.selected)
    }
    if (this.items.length && !this.selection) {
      this.selected = this.items[0][this.valueAttribute]
      this.$emit('update:selection', this.selected)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/GroupedDropDown.vue